import { useQuery } from "react-query";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface ApiResponse {
  unread_count: number;
}

export const useUnreadConversations = () => {
  const unreadConversations = (): Promise<ApiResponse> =>
    reactQueryGet(internalApi.helpWidget.unreadConversations());

  return useQuery(
    ["help-widget", "conversations", "unread-count"],
    unreadConversations,
  );
};
